import type { CalendarBot } from '../services/calendarWebSocketService';
import {
  BOT_NOT_ADMITTED_COPY,
  BOT_NOT_ADMITTED_REASONS,
  BotNotAdmittedReason,
} from '../constants/botAdmission';

type NotAdmittedReport = Partial<Pick<CalendarBot, 'status' | 'notAdmitted' | 'notAdmittedReason'>>;

const isKnownReason = (reason: unknown): reason is BotNotAdmittedReason =>
  (BOT_NOT_ADMITTED_REASONS as ReadonlyArray<unknown>).includes(reason);

/**
 * Why a bot that was never let in ended, from calendar `bot_terminated`; null
 * for a normal end. Only `notAdmitted: true` counts (an older server sends
 * neither field); a missing or unrecognised reason is `unknown`.
 */
export const notAdmittedReasonOf = (bot: NotAdmittedReport | null | undefined): BotNotAdmittedReason | null => {
  if (bot?.status !== 'terminated' || bot?.notAdmitted !== true) return null;
  const reason = bot?.notAdmittedReason;
  return isKnownReason(reason) ? reason : 'unknown';
};

/** What the rep reads under "Bot not let in". */
export const notAdmittedMessage = (reason: BotNotAdmittedReason): string =>
  BOT_NOT_ADMITTED_COPY.messages[reason] ?? BOT_NOT_ADMITTED_COPY.messages.unknown;
